module.exports = __webpack_public_path__ + "static/img/组 2899.d48f3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/declaration/images/组 2899.png
// module id = Fevz
// module chunks = 0